import React, { Fragment } from "react";
import { Trans } from "react-i18next";
import "../../assets/CSS/footer.css";

const Footer = () => {
    return (
        <>
            <footer className="main-footer" id="main-footer">
                <div>
                    <Trans i18nKey="copyright"> Copyright </Trans> &copy;{" "}
                    {new Date().getFullYear()} NeoSpectra&trade;.{" "}
                    <Trans i18nKey="allRightsReserved">
                        All rights reserved.{" "}
                    </Trans>
                </div>
            </footer>
        </>
    );
};

export default Footer;
